import Switch from '@mui/material/Switch';
import { useEffect, useState } from 'react';
import styles from '../../../ApplicationMaintenance.module.scss';
import { Button } from '@upmc/ims.component-library';
import MaterialIcon from '@material/react-material-icon';
import { DataTable } from '../../../../../components/UI/MDC/DataTable/DataTable';
import Section from '../Section';
import Modal from '@mui/material/Modal';
import Base from '../../../../Base/Base';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { GetUserTypes } from '../../../_api';
import { ServiceAccountType } from '../../../../../Classes/ResponseModels/ApplicationManagement/AppManagementModel';
import { nanoid } from 'nanoid';
//param @app : AppManagementModel
//param @setApp : function
const ServiceAccountForm = ({
	app,
	setApp,
	actions = null,
	disabled = false,
	handleSaveOverride = null,
	serviceAccountFlowEnabled = false,
	disableServiceAccountOnlyToggle = false,
}) => {
	const [isServiceAccountEnabled, setIsServiceAccountEnabled] = useState(
		serviceAccountFlowEnabled
	);

	const DetermineIsServiceAccountOnly = () => {
		if (
			app?.isServiceAccountOnly !== null ||
			app?.isServiceAccountOnly !== undefined
		) {
			return app?.isServiceAccountOnly;
		} else {
			return app?.appMaster.activeFlag;
		}
	};

	const setServiceAccountTypes = updatedServiceAccountTypes => {
		setApp({ ...app, serviceAccountTypes: updatedServiceAccountTypes });
	};

	return (
		<div>
			<p>Enable Service Account Request Flow</p>
			<Switch
				checked={isServiceAccountEnabled}
				onClick={e =>
					setIsServiceAccountEnabled(!isServiceAccountEnabled)
				}
			/>

			{isServiceAccountEnabled ? (
				<>
					{/* isServiceAccountOnly: if set to true, sets T_ApplicationMaster F_Active flag to false upon submission (within api) */}
					<p>
						App is Service account only (omit from standard app
						request flow)
					</p>
					<Switch
						checked={DetermineIsServiceAccountOnly()}
						onClick={e =>
							setApp({
								...app,
								isServiceAccountOnly: !app.isServiceAccountOnly,
							})
						}
						disabled={disableServiceAccountOnlyToggle}
					/>
					<br />
					<ServiceAccountTypesTable
						serviceAccountTypes={app?.serviceAccountTypes}
						setServiceAccountTypes={setServiceAccountTypes}
						actions={actions}
						disabled={disabled}
					/>
					<ServiceAccountTypeForm
						app={app}
						setApp={setApp}
						handleSaveOverride={handleSaveOverride}
					/>
				</>
			) : null}
		</div>
	);
};

export default ServiceAccountForm;

export const ServiceAccountTypesTable = ({
	serviceAccountTypes,
	setServiceAccountTypes,
	actions = null,
	disabled,
}) => {
	const [disableDelete, setDisableDelete] = useState(disabled);
	const headers = [
		{ Value: 'Actions', props: { sort: null, onSortChange: null } },

		{ Value: 'Account Type', props: { sort: null, onSortChange: null } },
	];

	const handleDelete = serviceAccountType => {
		setDisableDelete(true);
		let updatedServiceAccountTypes = serviceAccountTypes.filter(
			type => type !== serviceAccountType
		);
		setServiceAccountTypes(updatedServiceAccountTypes);
		setDisableDelete(false);
	};

	const rows = serviceAccountTypes?.map((serviceAccountType, index) => {
		return {
			Cells: {
				Actions: {
					Value: actions ? (
						actions(serviceAccountType)
					) : (
						<Button
							startIcon={<MaterialIcon icon='delete' />}
							onClick={e => handleDelete(serviceAccountType)}
							disabled={disableDelete}
						>
							Delete
						</Button>
					),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},

				'Account Type': {
					Value:
						(serviceAccountType.subUserType.Full ??
							serviceAccountType.subUserType.full) +
						' (' +
						serviceAccountType.subUserTypeID +
						')',
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
			},
			Key: nanoid(),
		};
	});

	return (
		<div>{rows ? <DataTable rows={rows} headers={headers} /> : null}</div>
	);
};

export const ServiceAccountTypeForm = ({
	app,
	setApp,
	handleSaveOverride = null,
}) => {
	const [modalOpen, setModalOpen] = useState(false);
	const [localServiceAccountType, setLocalServiceAccountType] = useState(
		new ServiceAccountType()
	);

	const handleUserTypeChange = e => {
		setLocalServiceAccountType({
			...localServiceAccountType,
			subUserTypeID: e.target.value.ID,
			subUserType: e.target.value,
		});
	};

	const handleSave = () => {
		if (handleSaveOverride === null) {
			let updatedServiceAccountTypes = [...app?.serviceAccountTypes];

			updatedServiceAccountTypes.push(localServiceAccountType);
			setApp({
				...app,
				serviceAccountTypes: updatedServiceAccountTypes,
			});
		} else {
			handleSaveOverride(localServiceAccountType);
		}
		setModalOpen(false);
	};
	return (
		<>
			<div className={styles.controlsContainer}>
				<Button
					variant='outlined'
					id='app_ComponentForm_modal_open'
					onClick={() => setModalOpen(!modalOpen)}
					startIcon={<MaterialIcon icon='add' />}
				>
					Add to Service Account Type
				</Button>
			</div>
			<Modal
				open={modalOpen}
				onClose={() => {
					setModalOpen(false);
				}}
			>
				<div className={styles.Modal}>
					<Base title='Service Account Flow'>
						<>
							<div className={styles.controlsContainer}>
								<Button
									onClick={e => {
										handleSave();
									}}
									outlined
									startIcon={<MaterialIcon icon='save' />}
									className={styles.editButton}
									id='createExtension_Save'
								>
									Save
								</Button>
							</div>

							<Section label='Add to Service Account type'>
								<UserTypeDropdown
									onChange={e => handleUserTypeChange(e)}
									localServiceAccountType={
										localServiceAccountType
									}
								/>
							</Section>
							<div className={styles.controlsContainer}>
								<Button
									onClick={e => {
										handleSave();
									}}
									outlined
									startIcon={<MaterialIcon icon='save' />}
									className={styles.editButton}
									id='createExtension_Save2'
								>
									Save
								</Button>
							</div>
						</>
					</Base>
				</div>
			</Modal>
		</>
	);
};

const UserTypeDropdown = ({ onChange, localServiceAccountType }) => {
	const [options, setOptions] = useState([]);

	useEffect(() => {
		GetUserTypes().then(response => {
			setOptions(response);
		});
	}, []);

	return (
		<>
			<p>Account Type</p>
			<Select
				labelId='UserTypeDropdown'
				id='UserTypeDropdown'
				value={localServiceAccountType.subUserType}
				label='UserType'
				onChange={e => onChange(e)}
			>
				{options.map(option => {
					return (
						<MenuItem key={option.ID} value={option}>
							{option.Full + ' (' + option.ID + ')'}
						</MenuItem>
					);
				})}
			</Select>
		</>
	);
};
